// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const timelyIntegrationCloudV1UserSchema = z.object({
  id: z.number().int(),
  name: z.coerce.string().min(1),
  avatar_url: z.coerce.string(),
  email: z.coerce.string(),
  tic_id: z.coerce.string().nullish(),
  origin_tic_identity_id: z.coerce.string().nullish(),
});
